// modules/audit/src/manifest.ts — AUDIT's nav contribution to the admin portal.
// One destination, because the module has one screen: the installation-wide
// trail. Everything else the trail powers is EMBEDDED — RecordHistory hangs on
// other modules' detail screens (modules/audit/src/fe), not on a route of its own.
//
// The API re-checks audit:read on every route (ADR-001 §14.2) — the menu only
// HIDES the affordance. A module-scoped reader (lib:admin without audit:read)
// deliberately does NOT see this entry: their trail access is the per-record
// panel on their own screens, not the global console.
import { ScrollText } from "lucide-solid";
import type { ModuleManifest } from "@erp/auth-kit/nav";

export const auditAdminNav: ModuleManifest = {
  id: "audit",
  module: "audit",
  label: "Audit trail",
  to: "/audit",
  icon: ScrollText,
  sections: [
    {
      id: "audit-trail",
      label: "Trail",
      items: [{ id: "audit-events", label: "All activity", to: "/audit", icon: ScrollText, perm: "audit:read" }],
    },
  ],
};

/** Every capability that admits a session to the audit console (any one suffices). */
export const AUDIT_CONSOLE_NAV_PERMS = ["audit:read"] as const;
